module.exports = __webpack_public_path__ + "static/training_oben_cropped-3e0bf093b36cea6f81c3ddf3dc037f48.jpg";